function HowToFetchApis(){
    return(
        <>
        </>
    )
}
export default HowToFetchApis;
